<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj profil' : 'Dodaj Użytkownika' }}</v-flex>

    <profile-form :schema="$schema" :edit="!!id" :show="show"></profile-form>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import { ProfileType } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/user.schema';
import Modal from '@/components/material/Modal';
import ProfileForm from '@/views/profile/ProfileForm';
import { manageMixin } from '@/mixins/manage';

function emptyData() {
  return {
    login: '',
    profile: {
      firstName: '',
      lastName: '',
      type: ProfileType.CLIENT,
      email: '',
      pesel: '',
      phoneNumber: '',
      woj: '',
      pow: '',
      gmi: '',
      terc: '',
      city: '',
      simc: '',
      street: '',
      ulic: '',
      postalCode: '',
      homeNumber: '',
      localNumber: '',
      confirmReason: '',
      confirmReasonDescription: '',
      mainImage: null
    }
  };
}

// @vuese
// Modal dodawnia/edycji profilu klienta
// @group Client-Profile
export default {
  components: { Modal, ProfileForm },
  mixins: [manageMixin('client', {}, emptyData)],
  schema
};
</script>
